import { createFileRoute } from "@tanstack/react-router"

import { PortalUsersAdminPage } from "@/features/admin/components/portal-users-admin-page"
import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"

export const Route = createFileRoute("/dashboard/settings/access-control/portal-users/")({
	component: PortalUsersAdminPage,
	beforeLoad: async ({ context }) => await requirePermissionRouteAccess(context.queryClient, "access.assignments.read"),
})
